import { Link } from "react-router-dom";
import { socialLinks } from "@/data/siteContent";

export const SiteFooter = () => {
  return (
    <footer
      className="border-t border-blue-200/20 bg-[#04143d]/85 px-4 py-10 sm:px-6 lg:px-10"
      data-testid="site-footer"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="space-y-3" data-testid="footer-brand-block">
          <h2 className="font-oswald text-xl uppercase tracking-[0.2em] text-white">Purnam Talent Management</h2>
          <p className="max-w-xl text-sm text-blue-100/80" data-testid="footer-brand-message">
            India's specialist agency connecting brands with athletes, creators, and sports-wellness communities.
          </p>
          <p className="text-xs text-blue-100/70" data-testid="footer-contact-line">inquiries@purnamtalent.com</p>
        </div>

        <div className="flex flex-wrap items-center gap-4" data-testid="footer-nav-links">
          {["About", "Athletes", "Services", "Partnerships"].map((item) => (
            <Link
              key={item}
              to={`/${item.toLowerCase() === "about" ? "about" : item.toLowerCase()}`}
              className="font-oswald text-xs uppercase tracking-[0.18em] text-blue-100/80 transition-colors duration-300 hover:text-accent"
              data-testid={`footer-link-${item.toLowerCase()}`}
            >
              {item}
            </Link>
          ))}
        </div>

        <div className="flex gap-4" data-testid="footer-social-links">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-blue-100/35 px-4 py-2 font-oswald text-xs uppercase tracking-[0.18em] text-blue-100/90 transition-colors duration-300 hover:border-accent hover:text-accent"
              data-testid={`social-link-${social.label.toLowerCase().replace(" ", "-")}`}
            >
              {social.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};